import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { UserNameDisplayResultDto } from '../../../../../_models/user-name-display-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { ARAdjustmentRawDto } from './ar-adjustment-raw-dto';
const ɵ0 = () => KeyValueResultDto, ɵ1 = () => KeyValueResultDto, ɵ2 = () => GLAccountSelectorResultDto, ɵ3 = () => DimensionSelectorResultDto, ɵ4 = () => UserNameDisplayResultDto, ɵ5 = () => ARAdjustmentRawDto, ɵ6 = () => Date;
export class ARAdjustmentEditorResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], ARAdjustmentEditorResultDto.prototype, "adjustmentTypes", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], ARAdjustmentEditorResultDto.prototype, "subLedgers", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], ARAdjustmentEditorResultDto.prototype, "glAccounts", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Array)
], ARAdjustmentEditorResultDto.prototype, "glDimensions", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], ARAdjustmentEditorResultDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", ARAdjustmentRawDto)
], ARAdjustmentEditorResultDto.prototype, "adjustmentInfo", void 0);
tslib_1.__decorate([
    Type(ɵ6),
    tslib_1.__metadata("design:type", Date)
], ARAdjustmentEditorResultDto.prototype, "closedBookPeriodDate", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
